import loadable from '@loadable/component'

export default [
  {
    path: '/crossroompk/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CrossRoomPkRule" */ '~/pages/CrossRoomPk/Rule'
        )
    ),
  },
  {
    path: '/crossroompk/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CrossRoomPkRank" */ '~/pages/CrossRoomPk/Rank'
        )
    ),
  },
]
